import Api from "shared/service/api/api";

export const LOAD_PAYOUT_REQUESTS = "loadPayoutRequests";
export const LOAD_TRANSACTIONS = "loadTransactions";
export const LOAD_PAYOUT_METHODS = "loadPayoutMethods";
export const LOAD_PAYOUT_METHOD_TYPES = "loadPayoutMethodTypes";
export const LOAD_PAYMENT_TYPES = "loadPaymentTypes";
export const LOAD_USER_BALANCES = "loadUserBalances";

export const SET_PAYOUT_REQUESTS = "setPayoutRequests";
export const SET_TRANSACTIONS = "setTransactions";
export const SET_PAYMENT_TYPES = "setPaymentTypes";
export const SET_USER_BALANCES = "setUserBalances";

const state = {
  datasets: {
    chargeTypes: [
      { id: 1, label: "Вывод средств" },
      { id: 2, label: "Перевод" },
      { id: 3, label: "Обмен Mone" },
    ],
    paymentTypes: [],
    userBalances: [],
  },
  payout_requests: {
    list: [],
    page: 1,
    page_count: 1,
  },
  transactions: {
    list: [],
    page: 1,
    page_count: 1,
  },
};

const actions = {
  [LOAD_PAYOUT_REQUESTS]({ commit }, { page }) {
    return Api.account.payout
      .all(page)
      .then((response) => {
        commit(SET_PAYOUT_REQUESTS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_TRANSACTIONS]({ commit }) {
    return Api.account
      .transactions()
      .then((response) => {
        commit(SET_TRANSACTIONS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_PAYMENT_TYPES]({ commit }) {
    return Api.account.paymentType
      .all()
      .then((response) => {
        commit(SET_PAYMENT_TYPES, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_USER_BALANCES]({ commit }) {
    Api.account
      .userBalances()
      .then((response) => {
        commit(SET_USER_BALANCES, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_PAYOUT_REQUESTS](state, { list, page, page_count }) {
    state.payout_requests.list = list;
    state.payout_requests.page = page;
    state.payout_requests.page_count = page_count;
  },
  [SET_TRANSACTIONS](state, { list, page, page_count }) {
    state.transactions.list = list;
    state.transactions.page = page;
    state.transactions.page_count = page_count;
  },
  [SET_PAYMENT_TYPES](state, data) {
    state.datasets.paymentTypes = data;
  },
  [SET_USER_BALANCES](state, data) {
    state.datasets.userBalances = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
